export const deviceConstants = {
    //name
    DEVICE: 'DEVICE',
    
    //events types
    SET_DEVICEINFO: 'SET_DEVICEINFO',    
    SET_LOGIN_PAGE: 'SET_LOGIN_PAGE',    
};